<template>
  <div class="flex">
    <select
      v-model="sizeSelected"
      class="ui fluid dropdown selection"
      style="height: 48px; width: 50px"
    >
      <option
        v-for="(sizeOption, index) in sizeOptions"
        :key="index"
        :value="sizeOption"
      >
        {{ sizeOption }}
      </option>
    </select>
    &nbsp;
    <div v-if="totalPages > 1">
      <button
        v-for="button in leftPages"
        :class="pageClass[button]"
        :key="button"
        @click="jumpToPage(button)"
      >
        {{ button }}
      </button>
    </div>

    <button
      v-for="button in middlePages"
      :class="pageClass[button]"
      :key="button"
      @click="jumpToPage(button)"
    >
      {{ button }}
    </button>
    <div v-if="totalPages > 1">
      <button
        v-for="button in rightPages"
        :class="pageClass[button]"
        :key="button"
        @click="jumpToPage(button)"
      >
        {{ button }}
      </button>
    </div>
  </div>
</template>
<style scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<script>
// import debounce from "lodash.debounce";
export default {
  name: 'Pagination',
  props: {
    count: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    sizeOptions: [10, 20, 30, 40, 50, 100],
    sizeSelected: 10,
    leftPages: ['<<', '<'],
    rightPages: ['>', '>>'],
    presentPage: 1
  }),
  computed: {
    totalPages() {
      return Math.ceil(this.count / this.size)
    },
    middlePages() {
      if (this.totalPages <= 10) {
        return Array.from({ length: this.totalPages }, (_, i) => i + 1)
      }

      const start = Math.floor((this.presentPage - 1) / 10)
      return Array.from(
        { length: Math.min(10, this.totalPages - start * 10) },
        (_, i) => start * 10 + i + 1
      )
    },
    pageClass() {
      const pageClassObj = {}
      this.leftPages.forEach((button) => {
        this.$set(pageClassObj, button, 'ui button tiny')
      })
      this.rightPages.forEach((button) => {
        this.$set(pageClassObj, button, 'ui button tiny')
      })
      this.middlePages.forEach((button) => {
        if (button === this.presentPage) {
          this.$set(pageClassObj, button, 'ui button tiny active')
        } else {
          this.$set(pageClassObj, button, 'ui button tiny')
        }
      })
      return pageClassObj
    }
  },
  watch: {
    sizeSelected(val) {
      this.$emit('selectSize', val)
    }
  },
  mounted() {
    this.sizeSelected = this.size
    this.presentPage = this.currentPage
  },
  methods: {
    jumpToPage(page) {
      let toPage = 1
      switch (page) {
        case '<<':
          break
        case '<':
          toPage = Math.max(1, this.presentPage - 1)
          break
        case '>':
          toPage = Math.min(this.totalPages, this.presentPage + 1)
          break
        case '>>':
          toPage = this.totalPages
          break
        default:
          toPage = page
          break
      }
      this.presentPage = toPage
      this.$emit('jumpToPage', toPage)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Pagination.vue?3a4088d1